import { useMemo } from 'react';
import { prop } from 'ramda';
import { useSetCurrentLanguage } from 'lang';
import { useUserSelector } from 'js/store/hooks';
import { languageService } from 'js/services/language.service';

export const useLanguagePublicAPI = () => {
    const currentLang = useUserSelector(prop('lang'));
    const setCurrentLanguage = useSetCurrentLanguage();

    return useMemo(() => ({
        /**
         * Retrieve current 5-symbols language, en_GB.
         * @memberOf Playtech.API.language
         * @function
         * @returns {String}
         * @example
         * // 'en_US'
         * Playtech.API.language.getCurrentLanguage();
         */
        getCurrentLanguage: () => currentLang,
        /**
         * Retrieve current 2-symbols language, en.
         * @memberOf Playtech.API.language
         * @function
         * @returns {String}
         * @example
         * // 'en'
         * Playtech.API.language.getTwoLetterLanguage('en_US');
         */
        getTwoLetterLanguage: (lang) => languageService.getTwoLetterLanguage(lang),
        /**
         * Set language.
         * @memberOf Playtech.API.language
         * @param langToSet {String} in 5-symbols format, en_GB, de_DE, ...
         * @function
         * @example
         * Playtech.API.language.setCurrentLanguage('en_GB');
         */
        setCurrentLanguage
    }), [currentLang, setCurrentLanguage]);
};
